import React, { Component } from 'react';
import { Col, Row, Card, CardBody, CardHeader} from 'reactstrap'
import { Helmet } from 'react-helmet'
import { isEmpty } from '../../common/utils'

import media from '../../assets/fontawesome/media_big.png'
import AppContext from '../../AppContext'
import './index.css'
const env = process.env.NODE_ENV || 'development';
const config = require('../../config.json')[env];
const admin_url = config.admin_url;
const ReactMarkdown = require('react-markdown')

const ApiSchema = ({name, value, last})=>(
  <React.Fragment>
    <span style={{color:'#f4bf75'}}>{name}</span>
    <span style={{color:'#d0d0d0'}}>:</span>
    <span style={{color:'#90a959'}}> {value}</span>
    {!last&&<span style={{color:'#d0d0d0'}}>,</span>}
    <br/>
  </React.Fragment>
  );

class Media extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data:[]
    }
  }
  componentDidMount(){
    console.log('calling',`${admin_url}/media`)
    const data = fetch(`${admin_url}/media`)
      .then(response => response.json())
      .then(res => this.setState({data:res}))
  }
  render() {
    
    if (isEmpty(this.state.data)) return null;
    const { data } = this.state

    return (
      <div className="animated fadeIn mainView" style={{height:'100%'}}>
        <Helmet>
          <title>Growjo Media: </title>
          <meta name="description" content='Growjo Media: ' />
          <meta name="author" content="Growjo" />
        </Helmet>       
      <Card style={{height:'100%'}}>
        <CardHeader style={{backgroundColor:'white'}}>
        <img src={media} style={{float:'left', marginRight:13,marginTop:4}}/><h1 style={{color:'#474866',fontSize:22,marginBottom:0}}>Media</h1>
        </CardHeader>
        <CardBody>
          <h4 style={{marginTop:10, marginBottom:30, color:'grey'}}>Here are the Media Outlets and Companies that have mentioned Growjo and/or their inclusion in the Growjo 1,000. </h4>
          <table className="media-table">
            {data.map(item=>
              <tr>
                <td className="image-wrapper">{item.logo&&<img src={`${admin_url}/${item.logo.url}`} className="media-image"></img>}</td>
                <td><ReactMarkdown source={item.description}/></td>
              </tr>
              )}
          </table>
        </CardBody>
      </Card>
      </div>
    );
  }
}

class MediaWrapper extends React.Component {
  render(){
    return (
      <Media data={this.context||[]}/>
    )
  }
}
MediaWrapper.contextType = AppContext;

export default MediaWrapper;



// WEBPACK FOOTER //
// ./client/src/views/Media/index.js